export type ModeType = "EDIT" | "VIEW"

// Enum in pathwright-blocks-server
export const BLOCKS_MODE = {
  EDIT: "EDIT",
  VIEW: "VIEW"
}

/** i18n key for the "Preparing content..." loading message during content migration. */
export const BLOCKS_PREPARING_CONTENT_KEY = "blocks.preparing_content"

/**
 * Custom event for refreshing a mounted Blocks document after an external migration.
 * Any mounted GraphQLSyncer will listen and call its reload handler so the current Step can refresh.
 */
export const BLOCKS_RELOAD_DOCUMENT_EVENT = "pathwright:blocks-reload-document"
